import { GenericFileReader } from 'uploader'

export class NodeFileReader extends GenericFileReader {
  private readonly fd: number

  constructor (private readonly fs, private readonly path: string, private readonly nameOverride: string) {
    super(nameOverride, fs.statSync(path).size)
    this.fd = fs.openSync(this.path, 'r')
  }

  async read (start: number, length: number): Promise<Blob> {
    return new Promise((resolve, reject) => {
      this.fs.read(this.fd, Buffer.alloc(length), 0, length, start, (err, bytesRead, buffer) => {
        if (err) {
          reject(err)
        } else {
          resolve(new Blob([buffer]).slice(0, bytesRead))
        }
      })
    })
  }

  close () {
    this.fs.closeSync(this.fd)
  }
}
